import { mainnet as viemMainnet } from 'viem/chains'

import type { AppChain } from './chain.types'

export const mainnet = {
  ...viemMainnet,
  custom: {
    name: 'Ethereum Mainnet',
    shortName: 'Ethereum',
    morphoChainSlug: 'ethereum',
    hasFullSupport: true,
    blockExplorer: { baseUrl: 'https://etherscan.io', name: 'Etherscan' },
    resetAllowanceBeforeApproveTokens: [
      '0xdAC17F958D2ee523a2206206994597C13D831ec7', // USDT
      '0xD533a949740bb3306d119CC777fa900bA034cd52' // CRV
    ],
    contracts: {
      v1: {
        AdaptiveCurveIrm: {
          address: '0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC',
          startBlock: 18883124n
        },
        MorphoBlue: {
          address: '0xBBBBBbbBBb9cC5e90e3b3Af64bdAF62C37EEFFCb',
          startBlock: 18883124n
        },
        MetaMorphoV10Factory: {
          address: '0xA9c3D3a366466Fa809d1Ae982Fb2c46E5fC41101',
          startBlock: 18925584n
        },
        MetaMorphoV11Factory: {
          address: '0x1897A8997241C1cD4bD0698647e4EB7213535c24',
          startBlock: 21439510n
        }
      },
      v2: {
        VaultV20Factory: {
          address: '0xA1D94F746dEfa1928926b84fB2596c06926C0405',
          startBlock: 23375073n
        },
        MorphoMarketV1AdapterFactory: {
          address: '0xb049465969ac6355127cDf9E88deE63d25204d5D',
          startBlock: 23375073n
        },
        MorphoMarketV1AdapterV2Factory: {
          address: '0x32BB1c0D48D8b1B3363e86eeB9A0300BAd61ccc1',
          startBlock: 23981459n
        },
        MorphoVaultV1AdapterFactory: {
          address: '0xD1B8E2dee25c2b89DCD2f98448a7ce87d6F63394',
          startBlock: 23375073n
        },
        RegistryList: {
          address: '0x3696c5eAe4a7Ffd04Ea163564571E9CD8Ed9364e',
          startBlock: 23375119n
        },
        BluePublicAllocator: {
          address: '0x00b8e1509398ED692C3F326CbAf1694F9A881e27',
          startBlock: 25770408n
        }
      }
    }
  }
} as const satisfies AppChain<{ v1: true; v2: true }>
